export default "__VITE_ASSET__cYdg2FIh__"